import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import "../styles/confirmationModal.css";
import axios from "axios";
import ErrorAlert from "../components/ErrorAlert";
import LoadingPage from "./LoadingPage";

//redux
import { connect } from "react-redux";
//font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";

class confirmationModal extends Component {
  state = {
    errorMessage: "",
    loading: false
  };

  handleReservation = async parkingName => {
    this.setState({ loading: true });
    try {
      axios
        .get(`/reserve/${parkingName}`)
        .then(response => response.data.redirectUrl)
        .then(redirectUrl => window.location.assign(redirectUrl))
        .catch(err => {
          console.log("err", err.response);
          this.setState({
            errorMessage: err.response.data.error,
            loading: false
          });
        });
    } catch (err) {
      console.error(err);
    }
  };

  handleResetErrorMessage = () => {
    this.setState({ errorMessage: "", loading: false });
  };

  render() {
    return (
      <div>
        {this.state.loading ? (
          <LoadingPage />
        ) : (
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <div className="modal-icon">
                <FontAwesomeIcon icon={faQuestion} />
              </div>
              <Modal.Title>Hello, {this.props.user.firstName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ErrorAlert
                message={this.state.errorMessage}
                handleResetErrorMessage={this.handleResetErrorMessage}
              />
              <span>Are you sure you want to reserve this spot?</span>
              <h1>{this.props.parkingToReserve}</h1>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.props.handleClose}>
                No
              </Button>
              <Button
                variant="primary"
                onClick={() =>
                  this.handleReservation(this.props.parkingToReserve)
                }
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(confirmationModal);
